module.exports = __webpack_public_path__ + "static/media/notice.df797655.svg";